import React from 'react';
import { Box } from '@saviynt/design-system';

import { TurnstileWidget } from '../../../../shared/components';
import { type CaptchaField } from '../../../../shared/types';

import styles from './PreviewFields.module.css';

interface CaptchaProps {
  // eslint-disable-next-line react/no-unused-prop-types
  field: CaptchaField;
  siteKey?: string;
  onToken?: (token: string) => void;
  isPreview?: boolean;
}

function Captcha({ siteKey, onToken, isPreview }: CaptchaProps) {
  return (
    <Box className={styles.captcha}>
      <TurnstileWidget siteKey={siteKey} onToken={onToken} />
      {isPreview && (
        <Box className={styles.captchaWidgetOverlay} aria-hidden='true' />
      )}
    </Box>
  );
}

export default Captcha;
